export { PaymentCard } from "./PaymentCard";
export { VacationRentalsPriceBreakdownDropdown } from "./VacationRentalsPriceBreakdownDropdown";

export const AGENT_FEE = 10;
